import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";
import AddHtml from '@/pages/trainCodeRule/addHtml.vue';

const Table = (args) => {
  const { listeners, props } = args;
  const isEnd = props.isEnd;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const handleDetete = listeners["handleDetete"] || function() {};

  const type = props.type;
  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let deletePremission = 'CourseTicketUserRange:delete'
    if (type == 3) {
      deletePremission = 'ticketUser:delete'
    }
    if (type == 4) {
      deletePremission = 'ticketLimit:delete'
    }
    let dealConf = [];
    if (type !== 3 && isEnd == 1) {
      dealConf = [
        [
          "icon-delete-disable",
          "删除",
          () => {},
          deletePremission,
        ],
      ];
    } else {
      dealConf = [
        [
          "icon-delete",
          "删除",
          () => {
            handleDetete(item);
          },
          deletePremission,
        ],
      ];
    }

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const StatusName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <AddHtml html={item.pushStatusName} />
    );
  };
  let AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "120", true),
    tableBaseProps("工作单位", "deptName", "m180", true),
    tableBaseProps("单位及职务", "unitPosition", "m180", true),
  ];
  // 线上、线下预约范围
  if (type == 1 || type == 2) {
    AccountTableConfig = AccountTableConfig.concat([
      tableBaseProps("管理主体", "leaderTypeName", "m100", true),
      tableBaseProps("近五年集中培训学时数", "totalLength", "m100", true),
      tableBaseProps("浙政钉绑定状态", "bindStatusName", "m90", true),
      {
        ...tableBaseProps("干部之家同步状态", "", "m140"),
        render: (vo) => <StatusName vo={vo} />,
      }
    ])
  }
  // 已预约名单
  if (type == 3) {
    AccountTableConfig = AccountTableConfig.concat([
      tableBaseProps("学习形式", "bizTypeName", "m100", true),
      tableBaseProps("预约时间", "ticketDate", "m140", true),
      {
        ...tableBaseProps("干部之家同步状态", "", "m150"),
        render: (vo) => <StatusName vo={vo} />,
      }
    ])
  }
  // 限制预约名单
  if (type == 4) {
    AccountTableConfig = AccountTableConfig.concat([
      tableBaseProps("上次预约学习形式", "bizTypeName", "m100", true),
      tableBaseProps("上次预约时间", "ticketDate", "m140", true),
    ])
  }
  

  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: 60,
    render: (vo) => <Deal vo={vo} />,
  })
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
